<template>
  <div>
    <i-button slot="top-buttons" size="large" type="primary" @click="add_media">
      {{ $t('pbx.media.list.add_media') }}
    </i-button>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  const formats = ['mp3', 'wav'];
  import { getBaseURL } from '@shared/helpers/url';
  import { MediaModalService } from '@pbx/modals/MediaModalService';

  export default {
    data: () => ({
      url: getBaseURL('/api/v2/pbx/mediafiles'),
      accept: formats.map(i => `.${i}`).join(','),
      format: formats,
      loading: false
    }),
    computed: {
      ...mapGetters('core/auth', ['user']),
      headers: function() {
        return {
          Authorization: `Bearer ${this.$store.getters['core/auth/token']}`
        };
      }
    },

    methods: {
      before_upload: function() {
        this.loading = true;
      },

      on_success: function(e) {
        this.loading = false;
        this.$emit('on-success', e);
      },

      add_media: function(e) {
        MediaModalService.add_media().on('success', () => this.getAsyncData());
        const upload_file_id = this.$R.pathOr('', ['id'], e);
        const user_key = this.user.user_key;

        this.$socket.client.on(`zrr.notify.notifications:${user_key}`, (payload) => {
          const file_id = this.$R.pathOr('', ['data', 'params', 'file_id'], payload);
          const type = this.$R.pathOr('', ['data', 'type'], payload);

          if (type === 'mediafile_conversion_complete' && upload_file_id === file_id) {
            this.loading = false;
            this.$emit('on-success', e);
          }
        })
      }
    }
  };
</script>
